(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
(function () {
    var T = __pewniaki_inline_cfg[0];
    var f3 = function (v) { return v == null ? '—' : Number(v).toFixed(3).replace('.', T.decimal); };
    var tys = function (v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };
    // Jedna ocena okna dla render i wnioski — obie drogi maja dawac te same liczby co SSR.
    var ocen = function (okno) {
        var ak = okno.autokorelacja || null, lag = ak && ak.lag ? ak.lag : {};
        var N = okno.losowan || 0;
        var n = ak && ak.n != null ? ak.n : N;
        var maCi = !!(ak && ak.ci95 != null) && okno.testy_powod == null;
        var wsp = [], poza = [], lagi = {};
        ['1', '2', '3'].forEach(function (L) {
            var v = lag[L];
            lagi[L] = v == null ? null : v;
            if (v == null) { return; }
            wsp.push(T.lag + ' ' + L + ': ' + f3(v));
            if (maCi && Math.abs(v) > ak.ci95) { poza.push(L); }
        });
        var zdanie = !wsp.length ? T.noCoefficients
            : (!maCi ? T.tooLittleShort
            : (!poza.length ? T.noneA + f3(ak.ci95) + T.noneB
            : T.outA + (JSON.parse(String(__pewniaki_inline_cfg[1])) ? poza.join(T.joiner) + T.outB : f3(ak.ci95) + T.outB) + (JSON.parse(String(__pewniaki_inline_cfg[2])) ? f3(ak.ci95) : poza.join(T.joiner)) + T.outC));
        return { N: N, n: n, ci: maCi ? ak.ci95 : null, maCi: maCi, wsp: wsp, poza: poza, lagi: lagi, zdanie: zdanie };
    };

    window.PEWNIAKI_ANALIZA = {
        plik:   '/assets/json/db/' + __pewniaki_inline_cfg[3] + '/analizy/sumy.json',
        wersja: __pewniaki_inline_cfg[4],
        lata:   false,
        wnioski: function (okno) {
            if (!okno) { return [T.noData]; }
            var o = ocen(okno);
            if (!o.wsp.length) { return [T.empty]; }
            var p = [T.introA + tys(o.N) + T.introB + tys(o.n) + T.introC + o.wsp.join(', ') + '.'];
            if (!o.maCi) {
                p.push(T.tooLittleLong);
            } else if (!o.poza.length) {
                p.push(T.noneA + f3(o.ci) + T.noneLongB + o.n + T.noneLongC);
            } else {
                p.push(T.outA + (JSON.parse(String(__pewniaki_inline_cfg[5])) ? o.poza.join(T.joiner) + T.outB + f3(o.ci) : f3(o.ci) + T.outB + o.poza.join(T.joiner)) + T.outLongC);
            }
            return p;
        },
        render: function (okno) {
            var q = function (s) { return document.querySelector(s); };
            var sekcja = q('[data-autokorelacja]');
            if (!okno) { if (sekcja) { sekcja.hidden = true; } return; }
            if (sekcja) { sekcja.hidden = false; }
            var o = ocen(okno);
            q('[data-autokorelacja-n]').textContent = tys(o.N);
            q('[data-autokorelacja-par]').textContent = o.wsp.length ? tys(o.n) : '—';
            q('[data-autokorelacja-ci]').textContent = o.maCi ? '±' + f3(o.ci) : '—';
            ['1', '2', '3'].forEach(function (L) {
                var v = o.lagi[L];
                q('[data-autokorelacja-lag="' + L + '"]').textContent = f3(v);
                q('[data-autokorelacja-poza="' + L + '"]').textContent = (v == null || !o.maCi) ? '—' : (o.poza.indexOf(L) >= 0 ? T.yes : T.no);
            });
            q('[data-autokorelacja-zdanie]').textContent = o.zdanie;
        }
    };
})();
})();
